import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// 페이지 및 컴포넌트 임포트 유지
import LandingPage from './Pages/LandingPage/LandingPage.js';
import Introduce from './Pages/Introduce/Introduce.js';
import Profile from './Pages/Profile/Profile.js';
import Case from './Pages/Case/Case.js';
import Location from './Pages/Location/Location.js';
import Contact from './Pages/Contact/Contact.js';
import NavBar from './Components/Layout/Navbar/NavBar.js';
import Footer from './Components/Layout/Footer/Footer.js';
import Fields from './Pages/Fields/Fields.js';
import QuickBar from './Components/Layout/QuickBar/QuickBar.js';
import PasswordPage from './Pages/PasswordPage/PasswordPage.js';

// 이미지 임포트 유지...
import IntroBgImg from './Assets/Img/introduceWebP.webp';
import BannerImg from './Assets/Img/BannerWebP.webp';
import ProfileImg1 from './Assets/Img/BaeWonsikProfileWebP.webp';
import Portrait1 from './Assets/Img/BaeWonsikPortrait.webp';

function App() {

  // 세션 스토리지에서 인증 상태 확인 (새로고침해도 유지됨)
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem('isAuthorized') === 'true'
  );

  const location = useLocation();

  useEffect(() => {
    const isExcludedPage = location.pathname === '/location';

    const handleContextMenu = (e) => {
      // 제외된 페이지거나 클릭한 요소가 .allow-drag 클래스를 가진 요소 내부라면 우클릭 허용
      if (isExcludedPage || e.target.closest('.allow-drag')) {
        return;
      }
      e.preventDefault();
    };

    // 드래그 방지 클래스 토글 (페이지 기준)
    if (isExcludedPage) {
      document.body.classList.remove('no-drag');
    } else {
      document.body.classList.add('no-drag');
    }

    document.addEventListener('contextmenu', handleContextMenu);
    return () => document.removeEventListener('contextmenu', handleContextMenu);
  }, [location]);

  useEffect(() => {
    // 1. 미리 불러올 이미지들을 배열로 정리
    const imagesToPreload = [IntroBgImg, BannerImg, ProfileImg1, Portrait1];

    const preloadImages = () => {
      imagesToPreload.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    };

    // 2. 브라우저가 현재 페이지 로딩을 완전히 마쳤는지 확인
    if (document.readyState === 'complete') {
      // 이미 로드가 끝난 상태라면 즉시 실행
      preloadImages();
    } else {
      // 아직 로드 중이라면 load 이벤트 발생 시 실행
      window.addEventListener('load', preloadImages);

      // 컴포넌트 언마운트 시 이벤트 리스너 제거 (메모리 관리)
      return () => window.removeEventListener('load', preloadImages);
    }
  }, []);

  // 인증 여부에 따른 컴포넌트 반환 함수
  const ProtectedRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/password" />;
  };

  return (
    <div className="app-container">
      {/* 관리자 인증이 안 된 경우 네비게이션을 숨길지 여부는 선택사항입니다 */}
      {isAuthenticated && <NavBar />}

      <main className="main-content">
        <Routes>
          {/* 비밀번호 입력 페이지 */}
          <Route path="/password" element={<PasswordPage setIsAuthenticated={setIsAuthenticated} />} />

          {/* 보호된 페이지들 */}
          <Route path="/" element={<ProtectedRoute><LandingPage /></ProtectedRoute>} />
          <Route path="/onpyeong" element={<ProtectedRoute><Introduce /></ProtectedRoute>} />
          <Route path="/fields" element={<ProtectedRoute><Fields /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/case" element={<ProtectedRoute><Case /></ProtectedRoute>} />
          <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
          <Route path="/location" element={<ProtectedRoute><Location /></ProtectedRoute>} />

          {/* 잘못된 경로 진입 시 비밀번호 페이지로 유도 */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>

      {isAuthenticated && <QuickBar />}
      {isAuthenticated && <Footer />}
    </div>
  );
}

export default App;